export default __webpack_public_path__ + "locales/tr/EmbeddingPanel.json?hash=1ccfdfee2475f3938456d291cc0aee1b";